module.exports = __webpack_public_path__ + "media/images/flags/en-79de20c502dab4d984fcb7d13bc28e17.svg";